import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { FinancialServiceViewWrapperComponent } from '@app/pages/quote/standard-quote/read-only/financial-service-view/financial-service-view-wrapper.component';

@Component({
  selector: 'app-financial-service-view-mobile',
  templateUrl: './financial-service-view-mobile.component.html',
  styleUrls: ['./financial-service-view-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FinancialServiceViewMobileComponent extends FinancialServiceViewWrapperComponent {

}
